import { useState, useEffect } from "react"

export function useGetCurrentDateTimeAsString(refreshIntervalMs = 1000) {
  const [now, setNow] = useState(() => {
    const d = new Date()
    const pad = (n: number) => n.toString().padStart(2, "0")
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  })
  useEffect(() => {
    const interval = setInterval(() => {
      const d = new Date()
      const pad = (n: number) => n.toString().padStart(2, "0")
      setNow(
        `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
      )
    }, refreshIntervalMs)
    return () => clearInterval(interval)
  }, [refreshIntervalMs])
  return now
}
